import React, { useEffect, useState } from 'react'
import StatusLabel from 'LuxKit/Label/StatusLabel'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Clickable from 'components/Common/Clickable'
import { rem } from 'polished'
import styled from 'styled-components'
import Modal from 'LuxKit/Modal/Modal'
import { getRemainingFlightSessionTime } from './utils'
import { FLIGHTS_SESSION_EXPIRATION_TIME_IN_MINUTES } from 'constants/flight'

const FlightSessionCountdownClockContainer = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  grid-gap:  ${rem(12)};
  justify-content: center;
`

const DescriptionAndInfoIcon = styled.div`
  align-items: center;
  display: flex;
`

const ClickableInfoIcon = styled(Clickable)`
  display: flex;
  margin-left: ${rem(4)};
`

const TimeFixedWidth = styled.div`
  display: inline-block;
  min-width: 2ch;
  text-align: center;
`

function convertNumberToTwoIntegerDigits(number: number) {
  return (number).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  })
}

export function FlightSessionCountdownClock() {
  const [timeRemaining, setTimeRemaining] = useState(getRemainingFlightSessionTime())
  const [infoModalOpen, setInfoModalOpen] = useState(false)

  useEffect(() => {
    // This will update the session storage every second
    const interval = setInterval(() => {
      setTimeRemaining(getRemainingFlightSessionTime())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  if (timeRemaining.minutes > FLIGHTS_SESSION_EXPIRATION_TIME_IN_MINUTES) {
    // Normally this will never be true because the countdown starts at FLIGHTS_SESSION_EXPIRATION_TIME_IN_MINUTES.
    // But for charter flights, the only expiry is the minimum lead time for flight bookings, which will normally be
    // much later than the usual 20 minute countdown. So this hides the timer for that case.
    return null
  }

  return (
    <>
      <FlightSessionCountdownClockContainer>
        <DescriptionAndInfoIcon>
          <BodyText variant="small" weight="bold">Flight prices subject to change</BodyText>
          <ClickableInfoIcon onClick={() => setInfoModalOpen(true)}>
            <LineInfoCircleIcon size="S" />
          </ClickableInfoIcon>
        </DescriptionAndInfoIcon>
        <StatusLabel variant="cancelled"><TimeFixedWidth>{convertNumberToTwoIntegerDigits(timeRemaining.minutes)}</TimeFixedWidth> : <TimeFixedWidth>{convertNumberToTwoIntegerDigits(timeRemaining.seconds)}</TimeFixedWidth> remaining</StatusLabel>
      </FlightSessionCountdownClockContainer>
      <Modal
        title="Prices subject to change"
        isOpen={infoModalOpen}
        onClose={() => setInfoModalOpen(false)}
      >
        <BodyText variant="medium">
          Due to demand and availability, flight prices can fluctuate quickly.
          We can hold your flights for a short period before your session expires. Secure your flights before prices increase!
        </BodyText>
      </Modal>
    </>
  )
}
